export default __webpack_public_path__ + "static/media/arrow_forward_green.db61de16.svg";